export default {
  apiPath: 'http://localhost:5000/api',
  emailAddress: 'super@localhost.com',
  password: 'password',
  rememberMe: true,
};
